<h1 mat-dialog-title>{{ 'isothermalCharacterizationEdit.sensorsConfig.title' | translate }}</h1>
<form>

  <div mat-dialog-content class="calibrates-theme" style="min-height: 10vh;">

    <div fxLayout="column">
      <div fxFlex>
        <span> {{ '¿Ubicación por bandejas?' | translate }} </span>
        <mat-radio-group [(ngModel)]="data.locationByTrays" name="locationByTrays">
          <mat-radio-button [value]="true"> {{'common.yes' | translate}} </mat-radio-button>
          <mat-radio-button [value]="false"> {{'common.no' | translate}} </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    @if (!data.locationByTrays) {
      <div fxLayout="column">
        <div fxFlex>
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.essay.sensors.numSensor.label' | translate }}</mat-label>
            <input matInput name="numSensor" [(ngModel)]="totalSensors" type="number" required min="1"
              (ngModelChange)="setNumSensor($event)">
          </mat-form-field>
        </div>
        <div fxFlex>
          @for (sensor of data.sensors; track sensor; let indexSensor = $index) {
            <div fxLayout="row" class="flexwrap">
              <div fxFlex="20" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'protocolEdit.dialog.essay.sensors.sensorNum.label' | translate }}</mat-label>
                  <input matInput name="numSensor{{indexSensor}}" value="{{ indexSensor + 1 }}" disabled>
                </mat-form-field>
              </div>
              <div fxFlex="70" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'protocolEdit.dialog.essay.sensors.location.label' | translate }}</mat-label>
                  <input matInput name="numSensor{{indexSensor}}" [(ngModel)]="sensor.location"
                    [disabled]="data.disabled">
                  <mat-error>
                    {{ 'protocolEdit.dialog.essay.sensors.location.error' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          }
        </div>
      </div>
    }

    @if (data.locationByTrays) {
      <div fxLayout="column">
        <div fxFlex>
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'isothermalCharacterizationEdit.sensorsConfig.trayNum.label' | translate }}</mat-label>
            <input matInput type="number" required name="trayNum" [(ngModel)]="trayNum" min="1"
              (ngModelChange)="onTrayNumChange($event)">
            <mat-error>
              {{ 'isothermalCharacterizationEdit.sensorsConfig.trayNum.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
        @for (tray of sensorTray | keyvalue; track tray) {
          <div fxFlex>
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'isothermalCharacterizationEdit.sensorsConfig.sensorTray.label' | translate: { num : (tray.key + 1) } }}</mat-label>
              <input matInput type="number" required name="sensorTray{{tray.key}}" min="0"
                [ngModel]="sensorTray.get(tray.key)" (ngModelChange)="sensorTray.set(tray.key, $event)">
              <mat-error>
                {{ 'isothermalCharacterizationEdit.sensorsConfig.sensorTray.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        }
      </div>
    }

  </div>

  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
    <div fxFlex="5px"></div>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>